import { createSlice } from "@reduxjs/toolkit";
import { initialFilter } from "../../pages/role/RoleUIHelpers";

const initialCustomersState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  roleForEdit: undefined,
  roleDefault: undefined,
  lastError: null,
  error: null,
  filters: initialFilter
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const roleSlice = createSlice({
  name: "roles",
  initialState: initialCustomersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    roleFetched: (state, action) => {
      state.actionsLoading = false;
      state.roleForEdit = action.payload.roleForEdit;
      state.error = null;
    },

    roleDefaultFetched: (state, action) => {
      state.actionsLoading = false;
      state.roleDefault = action.payload.roleDefault;
      state.error = null;
    },

    rolesFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // createCustomer
    roleCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.role);
    },
    // updateCustomer
    roleUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map((entity) => {
        if (entity.id === action.payload.role.id) {
          return action.payload.role;
        }
        return entity;
      });
    },
    roleFilter: (state, action) => {
      state.listLoading = false
      state.error = null
      state.filters = action.payload
    }
  },
});
